import { KEYS } from 'app/constants/SceneConstants';
import { FONT_BASE } from '../constants/AppFonts';
import ShortcutController from '../shortcuts/ShortcutController';
import SceneBaseTT from './SceneBaseTT';

export default class EnemyViewer extends SceneBaseTT {
  constructor() {
    super({ key: KEYS.EnemyViewer, active: false });
  }

  create() {
    super.create();
    this.setBackgroundColour();
    this.game.hud.setState('EMPTY');
    this.game.setShortcuts(ShortcutController.STATES.ENEMY_VIEWER);
    this.game.events.on('EXIT_TEST', this.game.showWelcome, this.game);
  }

  changeCharacter(e) {
    if (this._spine) this._spine.destroy();
    this._spine = this.add.spine(600, 500, e, 'walk_e', true);
    if (this._spine.getSkinList().includes('normal')) {
      this._spine.setSkinByName('normal');
    }
    if (e === 'dragon') {
      this._spine.y = 100;
    }
    this._spine.on('event', this.handleSpineEvent, this);
    this.renderAnimations(this._spine.getAnimationList());
  }

  handleSpineEvent(t, e) {
    switch (e.data.name) {
      case 'sfx':
        if (e.stringValue) this.game.soundController.playSFX('sfx', e.stringValue);
        break;
    }
  }

  renderAnimations(anims) {
    if (this._anims) this._anims.forEach((a) => a.destroy());

    this._anims = anims.map((a, i) => {
      const ty = i > 20 ? 50 + 30 * (i - 20) : 50 + 30 * i;
      const btn = this.add.text(i > 20 ? 1100 : 800, ty, a, {
        fontFamily: FONT_BASE.REGULAR,
        fontSize: 20,
        fill: '#000000',
      });
      btn.setInteractive({ useHandCursor: true });
      btn.on('pointerdown', () => {
        this._spine.play(a);
      });
      return btn;
    });
  }

  shutdown() {
    this.game.events.off('EXIT_TEST', this.game.showWelcome, this.game);
    super.shutdown();
  }
}
